var map = {
	"./banner_airports_insurance.png": 75555,
	"./banner_bicycle_insurance.png": 54674,
	"./banner_golf_insurance.png": 16831,
	"./banner_insurance_menu.png": 72876,
	"./banner_tyoinori_car_insurance.png": 8635,
	"./close.png": 42723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26847;